import React from 'react';
import {Modal, Alert, Radio} from '@enos/dpl';
import {observer, inject} from 'mobx-react';
import localeText from '@locale';
import darkTheme from '~/assets/images/dark_theme.png';
import greenTheme from '~/assets/images/green_theme.png';
import {THEME_DARK, THEME_GREEN, THEME_DEFAULT} from '~/utils/constants';
import uiStore from '../store';
import './index.less';

@inject('userStore', 'sessionStore')
@observer
class ChangeTheme extends React.Component {
  onCancel = () => {
    uiStore.setThemeModalVisibility(false);
  };

  handleRadioChange = (e) => {
    const {userStore, sessionStore} = this.props;
    sessionStore.setUserTheme(e.target.value);
    userStore.modifyUserProfile(e.target.value);
  };

  render() {
    return (
      <Modal
        maskClosable={false}
        className='change-theme-modal'
        title={localeText('COMMON.TITLE_CHANGE_THEME')}
        visible={uiStore.themeModalVisible}
        onCancel={this.onCancel}
        destroyOnClose
        footer={false}
      >
        <Alert message={localeText('COMMON.TXT_CHANGE_THEME_HINT')} showIcon />
        <div className='theme-list'>
          <Radio.Group value={this.props.sessionStore.theme || THEME_DEFAULT} onChange={this.handleRadioChange}>
            <Radio value={THEME_DARK}>
              {localeText('COMMON.TXT_DARK_THEME')}
              <img className='theme-img' src={darkTheme} alt='drak theme' />
            </Radio>
            <Radio value={THEME_GREEN} className='green'>
              {localeText('COMMON.TXT_BLUE_THEME')}
              <img className='theme-img' src={greenTheme} alt='green theme' />
            </Radio>
          </Radio.Group>
        </div>
      </Modal>
    );
  }
}
export function showChangeThemeModal() {
  uiStore.setThemeModalVisibility(true);
}

export default ChangeTheme;
